import {ManagedModelType} from 'models/ManagedModelDefinitions';
import AllModelManager from 'models/managers/AllModelManager';
import {getStore} from 'redux-stores/Store';
import * as RequestTaskSchemaReduxActions from 'requests/schemas/RequestTaskSchemaReduxActions';
import {RequestTaskSchema} from 'requests/tasks/RequestTaskConstants';

export default class AllRequestTaskSchemasModelManager extends AllModelManager<ManagedModelType.ALL_REQUEST_TASK_SCHEMAS> {
  constructor() {
    super(ManagedModelType.ALL_REQUEST_TASK_SCHEMAS);
  }

  async doFetchAll(): Promise<void> {
    await getStore().dispatch<Promise<void>>(RequestTaskSchemaReduxActions.fetchAll());
  }

  getAll(): Array<RequestTaskSchema> | null {
    const {requestTaskSchemasById} = getStore().getState().models.requests.schemas;
    if (requestTaskSchemasById == null) {
      return null;
    }
    return Object.values(requestTaskSchemasById);
  }
}
